import moment from 'moment';
import api from '../utils/api';

export default {
    namespaced: true,
    state: {
        redirect: undefined,
        issuer: {
            Id: undefined,
            Name: undefined,
            Picture: undefined,
        },
        intent: undefined,
        consent: {
            Expiration: moment().add(1, 'years').startOf('day').format('YYYY-MM-DD'),
        },
        consents: undefined,
        filter: 'all',
    },
    getters: {
        issuer(state) {
            return state.issuer;
        },
        intent(state) {
            return state.intent;
        },
        consent(state) {
            return state.consent;
        },
        redirect(state) {
            return state.redirect;
        },
        isAcceptable(state) {
            return state.redirect && state.intent;
        },
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        SAVE_CONSENTS(state, data) {
            state.consents = data;
        },
        SAVE_PARAMS(state, { issuer, intent, redirect, consent }) {
            if (issuer) state.issuer = issuer;
            if (intent) state.intent = intent;
            if (redirect) state.redirect = redirect;

            state.consent = consent || { Expiration: moment().add(1, 'years').startOf('day').format('YYYY-MM-DD') };
        },
        UPDATE_EXPIRATION(s, value) {
            if (moment(value).isSameOrBefore(moment())) {
                s.consent.Expiration = s.consent.Expiration;
            } else {
                s.consent.Expiration = moment(value).startOf('day').format('YYYY-MM-DD');
            }
        },
        FILTER(state, value) {
            state.filter = value;
        },
    },
    watch: {
    },
    actions: {
        LOAD_MY_CONSENTS(context) {
            const filter = context.state.filter;
            return api
                .get(`/consents?filter=${filter}`)
                .then(response => context.commit('SAVE_CONSENTS', response.data))
                .catch((error) => {
                    context.commit('SAVE_CONSENTS', []);
                    context.commit('errors/ADD', error, { root: true });
                });
        },
        LOAD_MY_CONSENTS_FILTER(context, filter) {
            if (filter !== context.state.filter) {
                /* eslint-disable no-console */
                console.log('filter changed from ', context.state.filter, ' to ', filter);
                context.commit('FILTER', filter);
                return api
                    .get(`/consents?filter=${filter}`)
                    .then(response => context.commit('SAVE_CONSENTS', response.data))
                    .catch((error) => {
                        context.commit('SAVE_CONSENTS', []);
                        context.commit('errors/ADD', error, { root: true });
                    });
            }

            /* eslint-disable no-console */
            console.log('filter was not changed from ', filter);
            return null;
        },
        LOAD_CONSENT(context) {
            const issuerId = context.rootState.route.params.issuer;
            const intentCode = context.rootState.route.params.intent;
            const redirect = context.rootState.route.query.redirect || '/consents';

            const issuer = {
                Id: issuerId,
                Name: 'Your Provider',
                Picture: undefined,
            };

            return api
                .get(`/${issuerId}/intents/${intentCode}`)
                .then(response => context.commit('SAVE_PARAMS', { issuer, intent: response.data, redirect }))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        ACCEPT(context) {
            const issuerId = context.state.issuer.Id;
            const intentCode = context.state.intent.Code;
            const redirect = context.state.redirect;
            const consent = {
                Expiration: moment(context.state.consent.Expiration).format(),
            };

            const issuer = {
                Id: issuerId,
                Name: 'Your Provider',
                Picture: undefined,
            };

            return api
                .post(`/${issuerId}/intents/${intentCode}/consent`, consent)
                .then(response => context.commit('SAVE_PARAMS', { issuer, intent: context.state.intent, redirect, consent: response.data }))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        REVOKE(context) {
            const issuerId = context.state.issuer.Id;
            const intentCode = context.state.intent.Code;

            return api
                .delete(`/${issuerId}/intents/${intentCode}/consent`)
                .then(() => context.commit('SAVE_PARAMS', { consent: undefined }))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/consents.js